import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';

type Props = {
  onChangedBody: (name: string, value: string) => void;
  motivation: string;
  target: string;
};

export const Component: FunctionComponent<Props> = ({
  onChangedBody,
  motivation: initialMotivation,
  target,
}) => {
  const [motivation, setMotivation] = useState('');
  const motivations = ['すぐに働きたい', '合う仕事があれば', '今は時間がありません'];

  useEffect(() => {
    setMotivation(initialMotivation);
  }, [initialMotivation]);

  const handleSelect = (selected: string) => {
    setMotivation(selected);
    onChangedBody(target, selected);
  };

  return (
    <Presentation
      motivation={motivation}
      motivations={motivations}
      onSelect={handleSelect}
    />
  );
};
